import { FC, Dispatch, SetStateAction, useState, useCallback } from 'react';
import classNames from 'classnames';
import { Button } from 'antd';

import { ReactComponent as IconReportError } from 'assets/report-error-nofill.svg';
import styled from 'styled-components';
import { useCurrentWidth } from 'new_shared/useWIndowDimensions';
import { useTypedTranslation } from 'translations/typedTranslations';
import i18n from 'i18n';
import { DOCENTE_FORM, ESTUDIANTE_FORM } from 'config/form';
import { ModalBody } from 'utils/ModalStyle';
import { CloseButton } from 'utils/CloseButton';
import { TipoUsuarioEnum } from 'enums/tipoUsuario';
import GoogleLogo from '../../../assets/google.png';
import ForwardArrow from '../../../assets/f-arrow.svg';
import MicrosoftLogo from '../../../assets/microsoft.svg';
import SwarmobLogo from '../../../assets/logo.svg';
import { LoginContraseña } from './LoginContraseña';

const selected = {
	'text-white': true,
	'bg-swarm-blue': true
};
const unSelected = {
	'text-swarm-light-gray': true,
	'border-gray-400': true,
	border: true
};

const DropShadowedButton = styled.div`
	background: #ffffff 0% 0% no-repeat padding-box;
	box-shadow: 0px 0px 6px #00000029;

	.ant-btn:hover,
	.ant-btn:focus,
	.ant-btn:active {
		background: #999999;
	}
`;

const LeftPanel: FC<{
	onChangeUser: (tipo: TipoUsuarioEnum) => void;
	currentUser: TipoUsuarioEnum;
	setPasswordValue: Dispatch<SetStateAction<string>>;
	onSubmitPassword: () => void;
	onAdminSignIn: () => void;
	onGoogleSignIn: () => void;
	onMicrosoftSignIn: () => void;
	hasError: boolean;
	noActive: boolean;
	customLoader: boolean;
	setUserRef: Dispatch<
		SetStateAction<{
			cursoKey: string;
			nombre: string;
			apellido: string;
			contraseña: string;
			colegioKey: string;
			institucionKey: string;
		}>
	>;
	userRef: {
		cursoKey: string;
		nombre: string;
		apellido: string;
		contraseña: string;
		colegioKey: string;
		institucionKey: string;
	};
}> = ({
	onChangeUser,
	currentUser,
	setPasswordValue,
	onSubmitPassword,
	onAdminSignIn,
	onGoogleSignIn,
	onMicrosoftSignIn,
	hasError,
	noActive,
	customLoader,
	setUserRef,
	userRef
}) => {
	const { t } = useTypedTranslation();
	const { mobileWidth } = useCurrentWidth();
	const [displayModal, setDisplayModal] = useState(false);

	const handleDisplayModal = () => {
		setUserRef({
			cursoKey: '',
			nombre: '',
			apellido: '',
			contraseña: '',
			colegioKey: '',
			institucionKey: ''
		});
		setDisplayModal((prev) => !prev);
	};

	const appliedStyles = (tipo: TipoUsuarioEnum) => (currentUser === tipo ? selected : unSelected);

	const changeToEN = useCallback(() => {
		i18n.changeLanguage(`en-CL`);
		localStorage.setItem('lng', `en-CL-login`);
	}, []);

	const changeToCL = useCallback(() => {
		i18n.changeLanguage(`es-CL`);
		localStorage.setItem('lng', `es-CL-login`);
	}, []);

	const UserSelect = (
		<>
			<img src={SwarmobLogo} width={mobileWidth ? 350 : 450} alt="swarm-logo" className="mt-10 mx-auto block" />
			<div className={`mt-${mobileWidth ? 2 : 10}`}>
				<div style={{ textAlign: 'center' }}>
					<Button type="link" className="p2" onClick={changeToCL}>
						Español
					</Button>
					<Button type="link" className="p2" onClick={changeToEN}>
						English
					</Button>
				</div>
			</div>
			<h5
				className={`text-center text-xl mt-${mobileWidth ? 2 : 10} text-swarm-orange tracking-widest font-bold`}
			>
				{t('SeleccionarUsuario')}
			</h5>

			<div className="mt-5 text-center">
				<button
					onClick={() => onChangeUser(TipoUsuarioEnum.estudiante)}
					type="button"
					className={classNames(
						'm-1 w-28 h-10 bg-clip-padding rounded-full focus:outline-none',
						appliedStyles(TipoUsuarioEnum.estudiante)
					)}
				>
					{t('Estudiante')}
				</button>
				<button
					onClick={() => onChangeUser(TipoUsuarioEnum.profesor)}
					type="button"
					className={classNames(
						'm-1 w-28 h-10 bg-clip-padding rounded-full focus:outline-none',
						appliedStyles(TipoUsuarioEnum.profesor)
					)}
				>
					{t('Docente')}
				</button>
				<button
					onClick={() => onChangeUser(TipoUsuarioEnum.coordinador)}
					type="button"
					className={classNames(
						'm-1 w-28 h-10 bg-clip-padding rounded-full focus:outline-none',
						appliedStyles(TipoUsuarioEnum.coordinador)
					)}
				>
					{t('Coordinador')}
				</button>
				{/* <button
					onClick={() => onChangeUser('colegios')}
					type="button"
					className={classNames(
						'm-1 w-28 h-10 bg-clip-padding rounded-full focus:outline-none',
						appliedStyles('colegios')
					)}
				>
					{t('Colegio')}
				</button> */}
				<button
					onClick={() => onChangeUser(TipoUsuarioEnum.monitor)}
					type="button"
					className={classNames(
						'm-1 w-28 h-10 bg-clip-padding rounded-full focus:outline-none',
						appliedStyles(TipoUsuarioEnum.monitor)
					)}
				>
					{t('Monitor')}
				</button>
			</div>
		</>
	);

	return (
		<div
			className="m-auto h-screen"
			style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
		>
			<ModalBody
				title={<>{t('Login con contraseña')}</>}
				visible={displayModal}
				mask
				closable
				destroyOnClose
				width={600}
				closeIcon={<CloseButton onClick={handleDisplayModal} />}
				footer={[]}
			>
				<LoginContraseña
					customLoader={customLoader}
					hasError={hasError}
					noActive={noActive}
					onSubmitPassword={onSubmitPassword}
					setPasswordValue={setPasswordValue}
					setUserRef={setUserRef}
					userRef={userRef}
					currentUser={currentUser}
				/>
			</ModalBody>
			<div>
				{UserSelect}
				{currentUser !== 'noUser' && (
					<>
						<h2 className="text-center text-4xl mt-5 text-swarm-blue font-bold">{t('IngresaASwarmob')}</h2>
						{/* {currentUser === 'estudiantes' ? ( */}
						<DropShadowedButton
							onClick={handleDisplayModal}
							style={{ background: '#fd8b26 0% 0% no-repeat padding-box' }}
							className="flex justify-between items-center mt-5 w-full h-10 bg-clip-padding  text-white rounded-full cursor-pointer"
						>
							<img className="ml-5 invisible" src={GoogleLogo} width={30} alt="google-logo" />
							<span className=" text-swarm-light-blue font-bold text-center">
								{t('Ingresa con tu contraseña Swarmob')}
							</span>

							<Button
								className="bg-swarm-purple text-white flex justify-center items-center mr-2 border-none"
								shape="circle"
								icon={<img src={ForwardArrow} alt="forward-arrow" />}
							/>
						</DropShadowedButton>
						{/* ) : (
							<> {ingresarWithClave}</>
						)} */}

						<DropShadowedButton
							onClick={onGoogleSignIn}
							className="flex justify-between items-center mt-5 w-full h-10 bg-clip-padding bg-gray-200 text-white rounded-full cursor-pointer"
						>
							<img className="ml-5" src={GoogleLogo} width={30} alt="google-logo" />
							<span className="text-swarm-gray font-bold text-center">{t('IngresarConGoogle')}</span>

							<Button
								className="bg-gray-500 text-white flex justify-center items-center mr-2 border-none"
								shape="circle"
								icon={<img src={ForwardArrow} alt="forward-arrow" />}
							/>
						</DropShadowedButton>
						<DropShadowedButton
							onClick={onMicrosoftSignIn}
							className="flex justify-between items-center mt-5 w-full h-10 bg-clip-padding bg-gray-200 text-white rounded-full cursor-pointer"
						>
							<img className="ml-5" src={MicrosoftLogo} width={30} alt="google-logo" />
							<span className="text-swarm-gray font-bold text-center">{t('IngresarConMicrosoft')}</span>

							<Button
								className="bg-gray-500 text-white flex justify-center items-center mr-2 border-none"
								shape="circle"
								icon={<img src={ForwardArrow} alt="forward-arrow" />}
							/>
						</DropShadowedButton>
					</>
				)}
			</div>
			<div className="mb-4 mt-10 flex">
				<div>
					<p className="text-swarm-gray ">{t('Ayudacontraseña')}</p>
					<p className="text-swarm-gray text-xs">{t('PreguntasSoporte')}</p>

					<button type="button" onClick={onAdminSignIn} className="text-swarm-gray text-xs">
						{t('IngresoAdmin')}
					</button>
				</div>
				{currentUser !== 'noUser' && (
					<a
						href={currentUser === TipoUsuarioEnum.estudiante ? ESTUDIANTE_FORM : DOCENTE_FORM}
						target="_blank"
						rel="noopener noreferrer"
						type="button"
						className="ml-4 mb-2"
					>
						<div className="flex justify-center">
							<IconReportError width={32} height={32} fill="#666" />
						</div>
						<div className="text-center text-swarm-gray">{t('Reportar error')}</div>
					</a>
				)}
			</div>
		</div>
	);
};

export default LeftPanel;
